/**
 * RoadmapItemLikesSheet
 *
 * Wrapper that opens the owner-only "users who liked / disliked this roadmap
 * item" UI via SheetService. Mirrors Flutter's `RoadmapItemLikesBottomSheet`
 * entry point — the drag-to-dismiss bottom sheet becomes a `SheetService`-driven
 * sheet (allowed web UI deviation).
 *
 * The like/dislike-count title is rendered inside the content (matching
 * Flutter's `_appBarTitle`), so the sheet `title` is left empty. The `likedType`
 * flag selects the like-vs-dislike copy and data branch.
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import { RoadmapItemLikesContent } from './RoadmapItemLikesContent';

export interface ShowRoadmapItemLikesSheetParams {
  roadmapItemId: string;
  /** `true` → users who liked; `false` → users who disliked. */
  likedType: boolean;
  likes: number;
  container?: HTMLElement | string | null;
  screenKey?: string;
  /**
   * Fixed sheet height. The caller must pass this (typically
   * `responsive.bottomSheet.maxHeight`) because this helper is a plain
   * function and cannot read `useResponsiveDesign()` itself.
   */
  fixedHeight?: string;
}

const show = ({
  roadmapItemId,
  likedType,
  likes,
  container,
  screenKey,
  fixedHeight,
}: ShowRoadmapItemLikesSheetParams) => {
  SheetService.show({
    title: '',
    content: (
      <RoadmapItemLikesContent
        roadmapItemId={roadmapItemId}
        likedType={likedType}
        likes={likes}
      />
    ),
    container,
    screenKey,
    fixedHeight,
    scrollable: false,
  });
};

export const RoadmapItemLikesSheet = {
  show,
};
